import { ButtonVariant, CoButton } from "components/CoButton";
import { INFLUENTIAL_CITATIONS_URL } from "constants/config";
import useLabels from "hooks/useLabels";

/**
 * @component InfluentialCitationsTooltip
 * @description Tooltip for explaining influential citattions
 * @example
 * <Tooltip
    tooltipContent={<InfluentialCitationsTooltip />}
    ...
  > ...
 */
const InfluentialCitationsTooltip = () => {
  const [tooltipsLabels] = useLabels("tooltips.influential-citations");

  const title = tooltipsLabels.title;
  const content = tooltipsLabels.content;
  const buttonText = tooltipsLabels["learn-more"];
  const buttonUrl = INFLUENTIAL_CITATIONS_URL;

  const handleClick = (e: any) => {
    e.preventDefault();
    window.open(buttonUrl);
  };

  return (
    <div className="flex flex-col gap-y-3">
      <p className="sm-bold">{title}</p>
      <p className="sm-normal">{content}</p>
      <CoButton
        onClick={handleClick}
        label={buttonText}
        iconRight="icon-external-link"
        variant={ButtonVariant.Tertiary}
        size="sm"
      />
    </div>
  );
};

export default InfluentialCitationsTooltip;
